<template>
    <div
        v-if="isShowedNotification"
        class="VNotification"
        :class="{'VNotification_active':isShowedNotification}"
    >
        <div class="VNotification__body">
            <div class="container">
                <div class="header">
                    {{ notificationData.headerText }}
                </div>
                <div class="content">
                    {{ notificationData.contentText }}
                </div>
                <div class="footer">
                    <VButton
                        v-if="notificationData.isShowedConfirmButton"
                        type="button"
                        theme="light-blue"
                        @click="confirmClick"
                    >
                        {{ notificationData.confirmText }}
                    </VButton>
                    <VButton
                        v-if="notificationData.isShowedCancelButton"
                        type="button"
                        theme="green"
                        @click="closeNotification"
                    >
                        {{ notificationData.cancelText }}
                    </VButton>
                </div>
            </div>
            <div
                v-if="notificationData.isShowedCloseButton"
                class="close-button"
                @click="closeNotification"
            >
            </div>
        </div>
    </div>
</template>

<script>
    import {eventBus} from '../main';
    
    export default {
        name: 'VNotification',
        data() {
            return {
                isShowedNotification: false,
                notificationData: {
                    headerText: '',
                    confirmText: 'OK',
                    cancelText: 'Cancel',
                    contentText: '',
                    eventConfirm: 'VNotificationConfirm',
                    isShowedCancelButton: true,
                    isShowedConfirmButton: true,
                    isShowedCloseButton: true,
                },
            };
        },
        created() {
            eventBus.$on('VNotificationShow', this.showNotification);
        },
        methods: {
            showNotification(notificationData) {
                document.body.style.overflow = 'hidden';
                this.isShowedNotification = true;
                this.notification = Object.assign(this.notificationData, notificationData);
            },
            closeNotification() {
                document.body.style.overflow = 'auto';
                this.isShowedNotification = false;
            },
            confirmClick() {
                eventBus.$emit(`${this.notificationData.eventConfirm}`, this.notificationData.data);
                this.closeNotification();
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .VNotification {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100vh;
        background: rgba(255, 255, 255, 0.8);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
        //pointer-events: none;
        opacity: 1;
        transition: all 1s ease-out;
        
        &__body {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 450px;
            background: white;
            border-radius: 10px;
            @include dark-shadow;
            
            .container {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                width: 390px;
                padding: 30px 0 20px 0;
                
                
                .header {
                    text-align: center;
                    font-size: 16px;
                    line-height: 20px;
                    color: #000F48;
                    font-weight: 700;
                    width: 70%;
                    word-break: break-word;
                }
                
                .content {
                    padding: 13px 0;
                    line-height: 18px;
                    text-align: center;
                    width: 100%;
                }
                
                .footer {
                    padding-top: 7px;
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;
                    
                    ::v-deep {
                        .VButton {
                            width: 60px;
                            
                            &_green {
                                margin-left: 10px;
                            }
                        }
                    }
                }
            }
            
            .close-button {
                cursor: pointer;
                position: absolute;
                top: -15px;
                right: -47px;
                width: 27px;
                height: 27px;
                background-position: center;
                background-size: contain;
                background-image: url("../../public/icons/components/VNotification/icon_add@1,5x.svg");
            }
        }
    }
</style>